import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import Header from './Header';
import Menu from './CommonMenu';
import SachNoiPageApi from './SachNoiPageApi';
import { FILE_URL } from './Constants';
import $ from 'jquery';

function SachNoiDetailPage() {
  const [searchParams] = useSearchParams();
  const postId = searchParams.get('postId');
  const [dataChiTiet, setDataChiTiet] = useState(null);
  const [tracks, setTracks] = useState([]);
  const [currentTrack, setCurrentTrack] = useState(null);
  const [loading, setLoading] = useState(true);

  const getVideoID = (url) => {
    if (!url) return null;
    const regex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^/\n\s]+\/|(?:v|e(?:mbed|d)?)\/|.*[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
    const match = url.match(regex);
    return match ? match[1] : null;
  };

  useEffect(() => {
    $('.tlt').textillate({
      loop: true,
      minDisplayTime: 20000,
      in: {
        effect: 'fadeIn',
        delayScale: 3,
        shuffle: false,
      },
      out: {
        effect: 'fadeOut',
        delayScale: 1.5,
        delay: 100,
        sync: false,
        shuffle: false,
        reverse: false,
      }
    });

    $("#sky-bg").fadeIn(2e3);
  }, []);

  useEffect(() => {
    if (!postId) {
      setLoading(false);
      return;
    }

    setLoading(true);
    setCurrentTrack(null);

    SachNoiPageApi.getDataByPostId(postId)
      .then((res) => {
        const detail = Array.isArray(res) && res.length > 0 ? res[0] : (res && res.data && res.data[0]) || null;
        if (detail) {
          const dateStr = detail.date_create || detail.Date_Create;
          if (dateStr) {
            const date = new Date(dateStr);
            detail.formattedDate = `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(2, '0')}/${date.getFullYear()}`;
          }
        }
        setDataChiTiet(detail);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });

    SachNoiPageApi.getTracksByParent(postId)
      .then((res) => {
        const list = Array.isArray(res) ? res : [];
        setTracks(list);
        // Mặc định phát track đầu tiên, giống trang cũ
        if (list.length > 0) {
          setCurrentTrack(list[0]);
        }
      })
      .catch(console.error);
  }, [postId]);

  // Ưu tiên Youtube: track nào có link Youtube thì nhúng Youtube, không có mới dùng MP3.
  const playing = currentTrack || dataChiTiet;
  const youtubeId = getVideoID(playing?.linkYoutube);
  const mp3Url = currentTrack
    ? currentTrack.linkMp3
    : (dataChiTiet?.Value || dataChiTiet?.value);

  const bookTitle = dataChiTiet?.Title || dataChiTiet?.title || '';
  const headingTitle = currentTrack
    ? `${bookTitle} - ${currentTrack.Title}`
    : bookTitle;

  return (
    <div>
      <meta httpEquiv="Content-Type" content="text/html; charset=UTF-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" />
      <meta httpEquiv="Content-Language" content="vi" />
      <title>{bookTitle || "Sách Nói"} | Linh Quy Pháp Ấn</title>
      <link rel="shortcut icon" href="/Upload/images/tab/logochuan.jpg" type="image/png" />

      <div className="fly-text">
        <ul>
          <li className="tlt">Nguyện thành tựu</li>
          <li className="tlt">Lòng tin bất động</li>
          <li className="tlt">Nơi Đức Phật, Chánh Pháp</li>
          <li className="tlt">Chúng Tăng và Thánh Giới</li>
          <li className="tlt" />
        </ul>
      </div>
      <div id="sky-bg">
        <div className="clouds_one" />
        <div className="clouds_two" />
        <div className="clouds_three" />
      </div>
      <Header />
      <section>
        <div className="container contentContainer">
          <div className="row">
            <div className="col-md-9 col-sm-9 col-xs-12">
              <Menu value={"sachnoi"} />

              {loading ? (
                <div style={{ padding: '50px 0', textAlign: 'center' }}>Đang tải...</div>
              ) : dataChiTiet ? (
                <div className="row" style={{ marginTop: '20px' }}>
                  <div className="col-md-12 col-sm-12 col-xs-12">

                    {/* ---------------- PLAYER ---------------- */}
                    <div className="audioContainer" style={{ textAlign: 'center', background: '#f5f5f5', padding: '20px', borderRadius: '8px', border: '1px solid #ddd' }}>
                      {youtubeId ? (
                        <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
                          <iframe
                            title={headingTitle}
                            src={`https://www.youtube.com/embed/${youtubeId}`}
                            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 0 }}
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                          />
                        </div>
                      ) : (
                        <>
                          {(dataChiTiet.Thumb || dataChiTiet.thumb) && (
                            <img
                              src={FILE_URL + (dataChiTiet.Thumb || dataChiTiet.thumb)}
                              alt={bookTitle}
                              style={{ maxWidth: '300px', width: '100%', borderRadius: '8px', marginBottom: '15px', boxShadow: '0 4px 8px rgba(0,0,0,0.1)' }}
                            />
                          )}
                          {mp3Url ? (
                            <audio key={mp3Url} controls style={{ width: '100%', marginTop: '10px' }}>
                              <source src={FILE_URL + mp3Url} type="audio/mpeg" />
                              Trình duyệt của bạn không hỗ trợ trình phát audio.
                            </audio>
                          ) : (
                            <p style={{ margin: '10px 0 0', color: '#666' }}>Chưa có file audio cho mục này.</p>
                          )}
                        </>
                      )}
                    </div>

                    {/* ---------------- THÔNG TIN ---------------- */}
                    <div className="chiTietVideoAudio" style={{ marginTop: '20px' }}>
                      <div className="row">
                        <div className="col-md-12">
                          <h1 style={{ color: '#80271A', fontSize: '24px', fontWeight: 'bold', borderBottom: '2px solid #FFD21D', paddingBottom: '10px' }}>
                            {headingTitle}
                          </h1>
                          <p className="thongTinSachNoi" style={{ fontSize: '14px', marginTop: '12px' }}>
                            {dataChiTiet.tacGia && <><b>Tác giả :</b> {dataChiTiet.tacGia}<br /></>}
                            {dataChiTiet.nxb && <><b>NXB :</b> {dataChiTiet.nxb}<br /></>}
                            {dataChiTiet.dich && <><b>Dịch :</b> {dataChiTiet.dich}<br /></>}
                            {dataChiTiet.dienDoc && <><b>Diễn đọc :</b> {dataChiTiet.dienDoc}<br /></>}
                          </p>
                          <p style={{ fontSize: '13px', color: '#666', marginTop: '10px' }}>
                            {dataChiTiet.formattedDate && <span>Ngày đăng: {dataChiTiet.formattedDate}</span>}
                            {(dataChiTiet.ViewedCount !== undefined) && <span style={{ marginLeft: '15px' }}>Lượt nghe: <strong>{dataChiTiet.ViewedCount}</strong></span>}
                          </p>
                          {(dataChiTiet.Description || dataChiTiet.description) && (
                            <div style={{ background: '#fafafa', borderLeft: '4px solid #FFD21D', padding: '10px 15px', margin: '15px 0', fontStyle: 'italic' }}>
                              {dataChiTiet.Description || dataChiTiet.description}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    {(dataChiTiet.Content || dataChiTiet.content) && (
                      <div className="rich-content" style={{ marginTop: '20px', lineHeight: '1.6', fontSize: '15px' }} dangerouslySetInnerHTML={{ __html: dataChiTiet.Content || dataChiTiet.content }} />
                    )}

                    {/* ---------------- DANH SÁCH TRACK ---------------- */}
                    {tracks.length > 0 && (
                      <div className="danhSachSachNoi" style={{ marginTop: '25px' }}>
                        <h5 className="tittleHome" style={{ marginBottom: 0 }}>
                          <i className="fa fa-list" /> DANH SÁCH
                        </h5>
                        <table className="table table-striped listAudio">
                          <tbody>
                            {tracks.map((track, index) => {
                              const isPlaying = currentTrack && currentTrack.id === track.id;
                              return (
                                <tr
                                  key={track.id}
                                  onClick={() => setCurrentTrack(track)}
                                  style={{ cursor: 'pointer', background: isPlaying ? '#FDEBD0' : undefined }}
                                >
                                  <td style={{ width: '40px' }}>
                                    <span className="count">{index + 1}</span>
                                  </td>
                                  <td>
                                    <a className="ten-audio" onClick={(e) => { e.preventDefault(); setCurrentTrack(track); }}>
                                      {track.Title}
                                    </a>
                                  </td>
                                  <td className="lefticonListAudio" style={{ width: '70px', textAlign: 'right' }}>
                                    {track.linkYoutube && <i className="fa fa-youtube-play" title="Có video Youtube" />}&nbsp;
                                    <a className="fa fa-plus-square iconDonwload2 btnAddFav" data-id={track.id} data-type="audio" data-title={track.Title} />&nbsp;
                                    <i className="fa fa-headphones" />
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>
                </div>
              ) : (
                <div style={{ padding: '50px 0', textAlign: 'center' }}>Không tìm thấy dữ liệu.</div>
              )}
            </div>

            {/* Sidebar */}
            <div className="col-md-3 col-sm-3 col-xs-12">
              <div className="boxNews" style={{ marginTop: '20px' }}>
                <div className="containerRightBox">
                  <h5 className="titleRightHome">LIÊN KẾT</h5>
                  <ul className="nav nav-pills nav-stacked listDanhMuc" style={{ padding: '10px 0' }}>
                    <li>
                      <a href="https://www.facebook.com/LINH-QUY-PH%C3%81P-%E1%BA%A4N-260666811038785/" target="_blank" rel="noreferrer">
                        <i className="fa fa-facebook fa-fw" /> Facebook
                      </a>
                    </li>
                    <li>
                      <a href="https://www.youtube.com/channel/UCnI54Nrr9AddC4pDdpIjyCg" target="_blank" rel="noreferrer">
                        <i className="fa fa-youtube fa-fw" /> YouTube
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
}

export default SachNoiDetailPage;
